export const parsePlayer = (player) =>
  player || {
    id: null,
    firstName: null,
    lastName: null,
    number: null,
    position: null,
    teamId: null,
  };

export const getPlayersById = (resp = []) => {
  const allPlayers = [];

  (Array.isArray(resp) ? resp : []).forEach((entry) => {
    const players = entry?.players;
    if (Array.isArray(players)) {
      allPlayers.push(...players);
    }
  });

  return allPlayers.reduce((acc, curr) => {
    return {
      ...acc,
      [curr.id]: {
        ...curr,
        firstName: parsePlayer(curr).firstName,
        id: parsePlayer(curr).id,
        lastName: parsePlayer(curr).lastName,
        fullName: `${parsePlayer(curr).firstName} ${parsePlayer(curr).lastName}`,
        number: parsePlayer(curr).number,
        position: parsePlayer(curr).position,
        teamId: parsePlayer(curr).teamId,
      },
    };
  }, {});
};
